module.exports = require("@angular/platform-browser/animations");


//////////////////
// WEBPACK FOOTER
// external "@angular/platform-browser/animations"
// module id = 840
// module chunks = 0